import { PaymentMethodModel } from "@/apidtos";
import { cn } from "@core/lib/utils";
import { useTranslation } from "react-i18next";

interface WalletBlockProps {
  containerClassName?: string;
  item: PaymentMethodModel;
}

export const WalletBlock = ({ containerClassName, item }: WalletBlockProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "border shadow-sm p-6 flex items-center",
        containerClassName
      )}
    >
      <div className="w-full">
        {item.TypeId == "CreditCard" ? (
          <div className="space-y-4">
            <h2 className="text-lg font-medium">{t(`ui.${(item.TypeId).replace(/\s+/g, "")}`, item.TypeId)}</h2>
            <p className="text-lg font-semibold tracking-widest">
              &bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;
              {item.CardLastFour}
            </p>
            <div className="flex justify-between">
              <div>
                <p className="text-sm text-slate-500">
                  {t("ui.cardholderName", "Cardholder Name")}
                </p>
                <p className="text-base font-medium">{item.CardHolderName}</p>
              </div>
              <div>
                <p className="text-sm text-slate-500">
                  {t("ui.validThrough", "Valid Through")}
                </p>
                <p className="text-base font-medium">{item.CardExpiration}</p>
              </div>
            </div>
          </div>
        ) : item.TypeId == "ACH" ? (
          <div className="space-y-4">
            <h2 className="text-lg font-medium">{t(`ui.${(item.TypeId).replace(/\s+/g, "")}`, item.TypeId)}</h2>
            <div className="flex justify-between">
              <div>
                <p className="text-xs text-slate-500">
                  {t("ui.accountNumber", "Bank Account Number")}
                </p>
                <p className="text-lg font-semibold">
                  &bull;&bull;&bull;&bull;&bull;&nbsp;{item.BankAccountLastFour}
                </p>
              </div>
              <div>
                <p className="text-xs text-slate-500">
                  {t("ui.routingNumber", "Routing Number")}
                </p>
                <p className="text-lg font-semibold">
                  &bull;&bull;&bull;&bull;&bull;&nbsp;{item.BankRoutingLastFour}
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div>
                <p className="text-xs text-slate-500">
                  {t("ui.accountName", "Account Holder Name")}
                </p>
                <p className="text-base font-medium">{item.Name}</p>
              </div>
              <div>
                <p className="text-xs text-slate-500">
                  {t("ui.bankName", "Bank Name")}
                </p>
                <p className="text-base font-medium">{item.BankName}</p>
              </div>
            </div>
          </div>
        ) : item.TypeId == "Credit" ? (
          <div className="space-y-4">
            <h2 className="text-lg font-medium">{t(`ui.${(item.TypeId).replace(/\s+/g, "")}`, item.TypeId)}</h2>
            <div className="flex justify-between">
              <div>
                <p className="text-xs text-slate-500">
                  {t("ui.originalBalance", "Original Balance")}
                </p>
                <p className="text-lg font-semibold">
                  { item.OriginalBalance ? `$${Math.round(Math.abs(item.OriginalBalance) * 100) / 100}` : `$0.00`}
                </p>
              </div>
              <div>
                <p className="text-xs text-slate-500">
                  {t("ui.remainingBalance", "Remaining Balance")}
                </p>
                <p className="text-lg font-semibold">
                  { item.CurrentBalance ? `$${Math.round(Math.abs(item.CurrentBalance) * 100) / 100}` : `$0.00`}
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div>
                <p className="text-xs text-slate-500">
                  {t("ui.name", "Name")}
                </p>
                <p className="text-base font-medium">{item.Name}</p>
              </div>
            </div>
          </div>
        ) : (
          <h2 className="text-lg font-medium">{t(`ui.${(item.TypeId)!.replace(/\s+/g, "")}`, item.TypeId!)}</h2>
        )}
      </div>
    </div>
  );
};
